import React from 'react'
import './basic-pie-chart.css'

const BasicPieChart = (props) => {
  const percentage = props.percentage
  return (
    <div className="basicPie basicPieSvgWrapper" style={{ '--p': percentage }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        className="basicPieSvg"
      >
        {/* <style>{`.eye{fill:#F9EC31;}`}</style> */}

        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="50%" y2="100%">
            <stop offset="0%" style={{ stopColor: '' }} />
            <stop offset="100%" style={{ stopColor: '' }} />
          </linearGradient>
        </defs>
        <circle id="bg-circle" cx="100" cy="100" r="80" />
        <circle
          id="fg-circle"
          stroke="url(#gradient)"
          cx="100"
          cy="100"
          r="80"
        />
      </svg>
      <span className="basicPieSpan ">{percentage}%</span>
    </div>
  )
}

export default BasicPieChart
